import * as React from 'react';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';

import './css/Site.css';
import './css/Fatture.css';

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

const sessione = new Session();
const config = new Config();
const azioni = new Azioni();
const utils = new Utils();

let _items: IDocument[] = [];

export class Moduli extends React.Component {

    constructor(){
        super();
        this.state = {
            moduli:[],
            errorMessage: '',
            id_cliente: false,
            
            visualizza:'',
            visualizzaWarning:'nascosto'
        };
        
        this._onChangeFiltraModuli = this._onChangeFiltraModuli.bind(this);

    }
                    
    componentDidMount() {
        this._popolaModuli();
        utils.setBoxInfoCliente();
    }
    
    _popolaModuli()
    {
        
        let request = new Request( config.get("anagrafica_moduli"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({ id_cliente: sessione.get('id_cliente')  })
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {
            
                _items = [];
                let visualizza= 'nascosto';
                let visualizzaWarning = 'warning centrato margin10';
                
                if( result.data !== null )
                {
                    // Elenco delle richieste
                    if ( result.data.length > 0) {
                        
                        visualizza= '';
                        visualizzaWarning = 'nascosto';
                        
                        for (let i = 0; i < result.data.length; i++) {
                          _items.push(result.data[i]);
                        }
                    }
                }
                this.setState({moduli: _items, visualizza:visualizza, visualizzaWarning:visualizzaWarning});
   
            } else {
                this.setState({errorMessage: result.message, visualizza:'nascosto', visualizzaWarning:'warning centrato margin10'});
            }
        }.bind(this) );
    }
    
    _onChangeFiltraModuli(event) {

        this.setState({ moduli: event.target.value ? 
            _items.filter(i =>  ( i.filename.toLowerCase().indexOf(event.target.value.toLowerCase() )  > -1 ) 
                         ) :  _items });
    };

    
    render() {

        return (
        <div id="inner-container">
            <Label className='ms-fontSize-xxl titolo-pagina'>Moduli<span id='boxdettagliocliente'></span></Label>

            <div id='filtri'>
                <div className='boxsearch'>
                <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Filtra per Moduli</span></label>
                
                <div id='ricercapod'>
                    <div className="ms-ComboBoxCustomStyledExample">
                        Ricerca <br/>

                        <div className="ms-TextField-wrapper wrapper_df60a678">
                            <div className="ms-TextField-fieldGroup fieldGroup_df60a678">
                                <input type="text" onChange={this._onChangeFiltraModuli} id="TextField81" className="ms-TextField-field field_df60a678 ms-font-m" />
                            </div>
                        </div>

                    </div>
                </div>


                </div>
             </div>
             
             <div id="warning" className={this.state.visualizzaWarning}>Nessun Modulo disponibile</div>
             

            <div id="elencorichieste"  className={"DetailListContainer " + this.state.visualizza}>
            
            <div id="scarico" >
            <CSVLink data={this.state.moduli} filename={"elenco_richieste.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
            </div>
            
            <DetailsList
                items={this.state.moduli}
                columns={ azioni.restituisciColonneModuli() }
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                selectionPreservedOnEmptyClick={true}
                onItemInvoked={this._onItemInvoked}
                compact={true}

              />
              </div>


              <div id="boxdialogo"></div>

        </div>
        );
    }
};

export default Moduli;


// WEBPACK FOOTER //
// ./src/AcComponents/Moduli.js